import { ActionContext } from "vuex"
import * as api from '@/api/okaso-api'
import * as Sentry from '@sentry/vue'

export interface LoginUserState {
  customer: api.Customer | null;
  staff: api.Staff | null;
}

export default {
  namespaced: true,
  state: (): LoginUserState => ({
    customer: null,
    staff: null,
  }),
  mutations: {
    setStaff (
      state: LoginUserState,
      user: api.Staff | null
    ) {
      state.staff = user
    },
    setCustomer (
      state: LoginUserState,
      customer: api.Customer | null
    ) {
      state.customer = customer
    },
    clear (state: LoginUserState) {
      state.staff = null
      state.customer = null
    }
  },
  getters: {
    staff: (state: LoginUserState) => {
      if (import.meta.env.VITE_SEINTRY_DSN) {
        Sentry.setUser({ username:  state.customer?.name + ' - ' + state.staff?.name, id: state.customer?.id ?? 0 })
      }
      return state.staff
    },
    customer: (state: LoginUserState) => state.customer,
  },
  actions: {
    set (context: ActionContext<LoginUserState, {}>, payload: { customer: api.Customer | null; staff: api.Staff | null; }) {
      context.commit('setStaff', payload.staff)
      context.commit('setCustomer', payload.customer)
    },
    setStaff (context: ActionContext<LoginUserState, {}>, payload: { staff: api.Staff | null; }) {
      console.log('setStaff', payload.staff)
      context.commit('setStaff', payload.staff)
    },
    setCompany (context: ActionContext<LoginUserState, {}>, payload: { customer: api.Customer | null; }) {
      context.commit('setCustomer', payload.customer)
    },
    clear (context: ActionContext<LoginUserState, {}>) {
      context.commit('clear')
    },
  }
}
